module.exports = __webpack_public_path__ + "HarshKarangutkar-04127fec.webp";